import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Agencies
export const fetchAgencies = createAsyncThunk(
  "agency/fetchAgencies",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/redeem/panel/agency");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Agency
export const addAgency = createAsyncThunk(
  "agency/addAgency",
  async (newAgency, { rejectWithValue }) => {
    try {
      const response = await api.post("/redeem/panel/agency", newAgency);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Agency
export const updateAgency = createAsyncThunk(
  "agency/updateAgency",
  async (agencyData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/redeem/panel/agency", agencyData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Agency Slice
const agencySlice = createSlice({
  name: "agency",
  initialState: {
    agencyList: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Agencies
      .addCase(fetchAgencies.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAgencies.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.agencyList = action.payload;
      })
      .addCase(fetchAgencies.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Agency
      .addCase(addAgency.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addAgency.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addAgency.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Agency
      .addCase(updateAgency.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateAgency.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateAgency.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = agencySlice.actions;

export default agencySlice.reducer;